import React, { useState } from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  TextField,
  Button,
  Typography,
  Container,
  Grid,
  Divider,
  IconButton,
  Stack,
  Tooltip,
  Avatar,
  Modal,
  Box,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { DeleteUser, updateUserInfoAction } from './APIs/action';
import { GetMeAction, logoutAction } from '../Onboarding/auth/action';
import { useNavigate } from 'react-router-dom';
import CheckIcon from '@mui/icons-material/Check';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { decodeToken, UserFileDict } from '../../utils/settings';
import FileInput from '../../components/fileInput/fileInput';

const UserDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginUser } = useSelector((state) => {
    return {
      loginUser: state.loginReducer.loginUser,
    };
  });

  const [isEditing, setIsEditing] = useState(false);

  const [userDetails, setUserDetails] = useState(loginUser);

  const handleEditClick = async () => {
    if (isEditing) await onUpdate();
    setIsEditing(!isEditing);
  };

  const handleDiscardClick = () => {
    setUserDetails(loginUser);
    setIsEditing(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserDetails({
      ...userDetails,
      [name]: value,
    });
  };
  const displayError = (message) => {
    setUserDetails(loginUser);
    return toast.error(message);
  };

  const onUpdate = async () => {
    if (!userDetails?.first_name) return displayError('First Name is required');

    const payload = {
      email: userDetails?.email,
      firstname: userDetails?.first_name,
      lastname: userDetails?.last_name,
      user_phone_number: userDetails?.phone_no,
    };

    const { error, message } = await updateUserInfoAction(payload);

    if (!error) {
      toast.success('Request has been sent for approval');

      const { error: userError, data: loggedInUser } = await GetMeAction();

      if (!userError) {
        setUserDetails(loggedInUser);
        dispatch({ type: 'SET_USER', data: loggedInUser });
      }
    } else {
      return displayError(message);
    }
  };
  const onDeletAccount = async () => {
    const { data, message, error } = await DeleteUser();
    if (!error) {
      await logoutAction();
      localStorage.clear();
      dispatch({ type: 'LOGOUT' });
      navigate('/login', { replace: true });
    } else return toast.error(message);
  };
  const [open, setOpen] = useState(false);
  const handleModalOpen = () => setOpen(true);
  const handleModalClose = () => {
    setOpen(false);
  };

  const deleteAccountModal = (
    <Modal
      open={open}
      onClose={handleModalClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          height: 300,
          bgcolor: 'background.paper',
          borderRadius: 5,
          boxShadow: 24,
          p: 4,
          justifyContent: 'center',
        }}
      >
        <Typography
          id='modal-modal-title'
          variant='h6'
          component='h2'
          sx={{
            fontWeight: 'bold',
            color: '#000000',
            marginTop: '1rem',

            textAlign: 'center',
          }}
        >
          Are you sure you want to Delete your account?
        </Typography>

        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          sx={{ marginTop: '3rem' }}
        >
          <Button
            variant='outlined'
            color='success'
            onClick={() => handleModalClose()}
          >
            No
          </Button>
          <Button
            variant='outlined'
            color='error'
            onClick={() => onDeletAccount()}
          >
            Delete Account
          </Button>
        </Stack>
      </Box>
    </Modal>
  );

  return (
    <>
      {deleteAccountModal}
      <Container
        maxWidth='true'
        sx={{ pl: '2rem', pt: '5rem' }}
      >
        <Typography variant='h4'>User Details</Typography>
        <Divider sx={{ mt: '1rem', mb: '3rem' }} />
        <Stack
          direction='column'
          spacing={2}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <Avatar
            alt={loginUser?.first_name}
            src={loginUser?.profile_image}
            sx={{ width: 200, height: 200 }}
          />

          <FileInput
            user_id={loginUser && loginUser.user_id}
            id={'photo'}
            file_type={UserFileDict['USER_PHOTO']}
            text={'Change Profile Picture'}
            accept={'image/jpeg, image/png'}
          />
        </Stack>
        <Card sx={{ mt: '5rem' }}>
          <CardHeader
            title='Basic Detail'
            sx={{ backgroundColor: '#f5f5f5' }}
            action={
              <Stack
                direction='row'
                spacing={2}
              >
                <Tooltip title={isEditing ? 'Save' : 'Edit'}>
                  <IconButton
                    color='primary'
                    onClick={handleEditClick}
                  >
                    {isEditing ? (
                      <CheckIcon sx={{ color: 'green' }} />
                    ) : (
                      <EditIcon />
                    )}
                  </IconButton>
                </Tooltip>
                {isEditing && (
                  <Tooltip title='Discard'>
                    <IconButton
                      color='primary'
                      onClick={handleDiscardClick}
                    >
                      <CloseIcon sx={{ color: 'red' }} />
                    </IconButton>
                  </Tooltip>
                )}
              </Stack>
            }
          />

          <CardContent>
            <Grid container>
              <Grid
                item
                xs={12}
                md={3}
                alignContent='center'
              >
                <Typography
                  variant='h6'
                  fontSize={15}
                >
                  First Name
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                md={5}
                alignContent='center'
              >
                <TextField
                  disabled={!isEditing}
                  label='First Name'
                  name='first_name'
                  value={userDetails?.first_name}
                  onChange={handleChange}
                  fullWidth
                  margin='normal'
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid
                item
                xs={12}
                md={3}
                alignContent='center'
              >
                <Typography
                  variant='h6'
                  fontSize={15}
                >
                  Last Name
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                md={5}
                alignContent='center'
              >
                <TextField
                  disabled={!isEditing}
                  label='Last Name'
                  name='last_name'
                  value={userDetails?.last_name}
                  onChange={handleChange}
                  fullWidth
                  margin='normal'
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid
                item
                xs={12}
                md={3}
                alignContent='center'
              >
                <Typography
                  variant='h6'
                  fontSize={15}
                >
                  Phone Number
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                md={5}
                alignContent='center'
              >
                <TextField
                  disabled={true}
                  label='Phone Number'
                  name='phone_no'
                  value={userDetails?.phone_no}
                  onChange={handleChange}
                  fullWidth
                  margin='normal'
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid
                item
                xs={12}
                md={3}
                alignContent='center'
              >
                <Typography
                  variant='h6'
                  fontSize={15}
                >
                  Email
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                md={5}
                alignContent='center'
              >
                <TextField
                  disabled={!isEditing}
                  label='Email'
                  name='email'
                  value={userDetails?.email}
                  onChange={handleChange}
                  fullWidth
                  margin='normal'
                />
              </Grid>
            </Grid>
            <Divider sx={{ mt: '3rem', mb: '1rem' }} />
            <Stack
              direction='row-reverse'
              spacing={2}
            >
              <Button
                variant='outlined'
                onClick={handleModalOpen}
                color='error'
              >
                Delete Account
              </Button>
            </Stack>
          </CardContent>
        </Card>
      </Container>
    </>
  );
};

export default UserDetail;
